module.exports = __webpack_public_path__ + "img/draft.eb0dea0e.svg";